import { colors } from '@chegg-ui/theme'
import styled, { css } from 'styled-components'
import { Special, Large, SpecialButtonLink } from '@chegg-wt/core/theme/fanta/button'
import { BodyLargeLightGray } from '@chegg-wt/core/theme/sunkist/typography'

export const CardContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: ${({ theme }) => theme.Colors.forInterface.interfaceColor11};
  border: 1px solid ${({ theme }) => theme.Colors.forInterface.interfaceColor13};
  height: 277px;
  width: 100%;
`

export const IconContainer = styled.div`
  display: flex;
  margin-bottom: 18px;
  justify-content: center;
`

export const IconContainerOriginal = styled.div`
  display: flex;
  background-color: ${colors.greyXlight};
  border-radius: 50%;
  margin-bottom: 16px;
  justify-content: center;
  height: 136px;
  width: 136px;
`

const ButtonCss = css`
  ${Special};
  ${Large};
  text-align: center;
`

export const Button = styled(SpecialButtonLink)``

export const ModalButton = styled.button`
  ${ButtonCss}
`

export const Context = styled.p`
  ${BodyLargeLightGray};
  text-align: center;
  margin-top: 16px;
  width: 233px;
  flex-basis: 50px;
`
